import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { reportError } from 'utils/error'
import { updateModalsKey } from './updateModalsKeys'
import { UpdateModal } from './useUpdateModals'

export interface Variables {
  update_modal_id: number
}

export const createUpdateModalView = async (variables: Variables) => {
  const response = await sendToApi(`/update_modals/${variables.update_modal_id}/update_modal_views`, {
    method: 'POST',
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError(response)
  }
  return true
}

export const useCreateUpdateModalView = ({
  onSuccess,
}: {
  onSuccess?: (id: number) => void
} = {}) => {
  const queryClient = useQueryClient()

  return useMutation<boolean, unknown, Variables>(
    'createUpdateModalView',
    async (variables) => {
      return createUpdateModalView(variables)
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.setQueryData(updateModalsKey, (data: UpdateModal[] | undefined) => {
          if (!data) return []

          return data.filter((updateModal) => updateModal.id !== variables.update_modal_id)
        })

        onSuccess?.(variables.update_modal_id)
      },
    },
  )
}
